<ngx-loading-bar
  #loading
  color="#3AA36B"
  includeSpinner="false"
  height="3px"
></ngx-loading-bar>

<div id="service-order-view">
  <app-new [title]="title" [subtitle]="subtitle" [urlBack]="urlBack">
    <div class="container" *ngIf="serviceOrder">
      <div class="row">
        <div class="col">
          <label>
            <span>BANDEIRA</span>

            <div class="text">
              {{ serviceOrder.loja.dsLogomarca | emptyResponse }}
            </div>
          </label>
        </div>

        <div class="col">
          <label>
            <span>LOJA</span>

            <div class="text">
              {{ serviceOrder.loja.nmFantasia | emptyResponse }}
            </div>
          </label>
        </div>

        <div class="col">
          <label>
            <span>DATA DE ABERTURA</span>

            <div class="text">
              {{ serviceOrder.dtAbertura | emptyResponse }}
            </div>
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label>
            <span>CNPJ</span>

            <div class="text">
              {{ serviceOrder.loja.nrCnpj | emptyResponse }}
            </div>
          </label>
        </div>

        <div class="col">
          <label>
            <span>CENTRO DE CUSTO</span>

            <div class="text">
              {{ serviceOrder.loja.centroCusto?.nmCentroCusto | emptyResponse }}
            </div>
          </label>
        </div>

        <div class="col">
          <label>
            <span>LOJA NOVA</span>

            <div class="text">
              {{
                serviceOrder.flNovaLoja == "0" ? "NÃO" : ("SIM" | emptyResponse)
              }}
            </div>
          </label>
        </div>

        <div class="col">
          <label>
            <span>ID JAVA DA LOJA</span>

            <div class="text">{{ serviceOrder.cdFilial | emptyResponse }}</div>
          </label>
        </div>
      </div>

      <h2>DETALHES DA MANUTENÇÃO</h2>

      <div class="row">
        <div class="col">
          <label>
            <span>PRESTADOR DE SERVIÇO</span>

            <div class="text">
              {{ serviceOrder.nmFantasia | emptyResponse }}
            </div>
          </label>
        </div>

        <div class="col">
          <label>
            <span>TIPO DO SERVIÇO</span>

            <div class="text">
              {{ serviceOrder.dsTpServico | emptyResponse }}
            </div>
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label>
            <span>RELATO DO CHAMADO</span>

            <div class="text">
              {{ serviceOrder.dsObservacao | emptyResponse }}
            </div>
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <h2>VALORES TOTAIS</h2>

          <div class="row">
            <div class="col">
              <label>
                <span>TOTAL GERAL</span>

                <div class="text">{{ total | currencyFormat }}</div>
              </label>
            </div>

            <div class="col">
              <label>
                <span>APROVAÇÃO</span>

                <div class="text">
                  {{ serviceOrder.dsAprovacao | emptyResponse }}
                </div>
              </label>
            </div>
          </div>
        </div>

        <div class="col">
          <h2 class="row">EXTRATO</h2>

          <label>
            <div class="row">
              <span class="col">EQUIPAMENTOS</span>
              <span class="col">VALOR UNIT.</span>
            </div>

            <table>
              <tr class="row" *ngFor="let item of serviceOrder.items">
                <td class="col">{{ item.dsProduto }}</td>
                <td class="col">{{ item.vlItem | currencyFormat }}</td>
              </tr>
            </table>
          </label>
        </div>
      </div>

      <!-- Precisa verificar se vai ter essa parte na visualização -->
      <!-- <h2>ASSINATURA DO GERENTE</h2>

      <div class="row">
        <div class="col">
          <label>
            <span>ASSINADO EM</span>

            <div class="text">00/00/0000</div>
          </label>
        </div>

        <div class="col">
          <label>
            <span>FOTO ANEXADA</span>

            <div class="text"><a href="">visualizar assinatura</a></div>
          </label>
        </div>
      </div> -->

      <!-- <div class="row">
        <div class="col">
          <button class="white" [routerLink]="returnLink">
            RETORNAR PARA LOJA
          </button>

          <button (click)="forwardServiceOrder()">
            ENCAMINHAR PARA PRESTADOR
          </button>
        </div>
      </div> -->
    </div>
  </app-new>
</div>
